export default {
    fsmRoute_modal_editCreate_create: "Routes",
    fsmRoute_modal_editCreate_edit: "Edit Route",
    fsmRoute_modal_editCreate_error_name: "Route duplicated title",
    fsmRoute_modal_editCreate_error_incorrect_route: "The point you are trying to create is in an invalid location, please place the point again in a valid location for the route.",
}